import { AppBar, makeStyles, Toolbar } from '@material-ui/core';
import { Link } from '@reach/router';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import LogoImageSrc from '../../assets/images/logo.png';
import { useAuth } from '../../contexts/AuthContext/AuthContext';
import { useCommonErrorWatcher } from '../../hooks/useCommonErrorWatcher';
import { useSnackbarMessage } from '../../hooks/useSnackbarMessage';
import { ROUTES } from '../../routes';
import Navigation from './Navigation';

interface OwnProps {}

const PageHeader: React.FC<OwnProps> = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { user } = useAuth();
  const [userAccess, setUserAccess] = useState(true);

  useEffect(() => {
    if (user) {
      setUserAccess(user.canAccess);
    }
  }, [user]);

  useSnackbarMessage(!userAccess, 'error:authError', {
    variant: 'warning',
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right',
    },
  });

  useCommonErrorWatcher();

  return (
    <AppBar className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <Link to={ROUTES.financialData.page} className={classes.logoLink}>
          <img src={LogoImageSrc} alt={t('app:royaltyLogoAlt')} />
        </Link>
        <div className={classes.rightBox}>
          <Navigation />
        </div>
      </Toolbar>
    </AppBar>
  );
};

const useStyles = makeStyles((theme) => ({
  appBar: {
    width: '100%',
    background: theme.palette.background.paper,
    boxShadow: 'none',
    position: 'static',
  },
  toolbar: {
    padding: 0,
  },
  logoLink: {
    width: '280px',
    flex: '0 0 280px',
    padding: '0 36px',
    '& img': {
      width: '100%',
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  rightBox: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    marginLeft: 'auto',
  },
  root: {
    width: '100%',
    maxWidth: 280,
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
}));

export default PageHeader;
